module.exports = __webpack_public_path__ + "img/HNTE2.22c30f06.jpg";